import { useFromInput } from '@ui/features/Trade/hooks/useFromInput';
import { useMarketPrice } from '@ui/features/Trade/hooks/useMarketPrice';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { usePriceLatest } from '@ui/hooks/price/usePriceLatest';
import { OrderType } from '@ui/types/trade';
import BigNumber from 'bignumber.js';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

import { useOrderType } from '../store/useOrderType';

export const useEntryPrice = () => {
  const marketPrice = useMarketPrice();
  const orderType = useOrderType((s) => s._persistValue);
  const isMarket = orderType === OrderType.MARKET;
  const triggerPrice = useFromInput((s) => s.input).triggerPrice; // fromUsd
  const triggerPriceNum =
    !isNil(triggerPrice) && !isNaN(Number(triggerPrice))
      ? Number(triggerPrice)
      : undefined;

  return isMarket ? marketPrice : triggerPriceNum;
};

export const useEntryPriceSnapshot = () => {
  const pair = useTradingPair((v) => v.useTradingPair());
  const marketPrice = usePriceLatest(pair.baseSymbol);
  const orderType = useOrderType((s) => s._persistValue);
  const triggerPrice = useFromInput((s) => s.input).triggerPrice; // fromUsd

  return useMemo(() => {
    const isMarket = orderType === OrderType.MARKET;

    return isMarket
      ? marketPrice
      : triggerPrice
      ? new BigNumber(triggerPrice)
      : undefined;
  }, [marketPrice, orderType, triggerPrice]);
};
